import { useEffect, useState } from 'react';

import { get as getUser } from 'js/lib/user';

// eslint-disable-next-line import/no-cycle
import {
  hasCompletedFirstModuleInLocalStorage,
  setHasCompletedFirstModuleToLocalStorage,
} from 'bundles/enroll/utils/freemiumModelUtils';
import { useNaptime } from 'bundles/naptimejs';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'bund... Remove this comment to see the full error message
import GuidedCourseSessionProgressesV1 from 'bundles/naptimejs/resources/guidedCourseSessionProgresses.v1';

type PropsFromNaptime = {
  guidedCourseSessionProgresses: GuidedCourseSessionProgressesV1;
};

export function useHasCompletedFirstModule({ courseId, skip = false }: { courseId: string; skip?: boolean }) {
  const [loadingRefresh, setLoadingRefresh] = useState(false);
  const hasCompletedFirstModuleLocalStorageValue = hasCompletedFirstModuleInLocalStorage(courseId);
  const userId = getUser()?.id;
  const {
    data: { guidedCourseSessionProgresses },
    pending,
    naptime,
  } = useNaptime<PropsFromNaptime>(() => {
    if (skip || !courseId || !userId || hasCompletedFirstModuleLocalStorageValue) return {};

    return {
      guidedCourseSessionProgresses: GuidedCourseSessionProgressesV1.multiGet([`${userId}~${courseId}`], {
        fields: ['weeks'],
      }),
    };
  }, [userId, courseId, skip, hasCompletedFirstModuleLocalStorageValue]);

  const triggerRefresh = () => {
    if (naptime && !hasCompletedFirstModuleLocalStorageValue) {
      setLoadingRefresh(true);
      naptime.refreshData({ resources: [GuidedCourseSessionProgressesV1.RESOURCE_NAME] }).then(() => {
        setLoadingRefresh(false);
      });
    }
  };

  const isFirstModuleCompleted =
    hasCompletedFirstModuleLocalStorageValue ||
    Boolean(guidedCourseSessionProgresses?.[0]?.weeks?.[0]?.weekStatus === 'COMPLETED');
  useEffect(() => {
    if (isFirstModuleCompleted && courseId) {
      setHasCompletedFirstModuleToLocalStorage(courseId);
    }
  }, [isFirstModuleCompleted, courseId]);

  return {
    hasCompletedFirstModule: isFirstModuleCompleted,
    loading: pending || loadingRefresh,
    triggerRefresh,
  };
}
